"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CurrencyFormat = _interopRequireDefault(require("./CurrencyFormat"));

var _TextField = require("../TextField");

/**
 * Text field for entering currency.
 * See [TextField](/#!/TextField) for props info.
 */
var Currency = function Currency(props) {
  return /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], (0, _extends2["default"])({
    startAdornment: "$"
  }, props));
};

Currency.propTypes = (0, _extends2["default"])({}, _TextField.TextFieldProps, {
  value: _propTypes["default"].number
});
var _default = Currency;
exports["default"] = _default;